import { TSuggestedFaqFormValues } from './types';
import { ISuggestedFaqBase } from '@/models/suggestedFaq.model';

export const getSuggestedFaqFormValues = (
  suggestedFaq?: Pick<ISuggestedFaqBase, 'question' | 'answer'> | null,
): Partial<TSuggestedFaqFormValues> => ({
  question: suggestedFaq?.question,
  answer: suggestedFaq?.answer ?? undefined,
});
